// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccountRouteImport } from './routes/account'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ForAuthorsRouteImport } from './routes/for-authors'
import { Route as ForGymsRouteImport } from './routes/for-gyms'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LiveRouteImport } from './routes/live'
import { Route as LolRouteImport } from './routes/lol'
import { Route as MatchupsRouteImport } from './routes/matchups'
import { Route as MembershipAppRouteImport } from './routes/membership-app'
import { Route as MonthlyRewardsRouteImport } from './routes/monthly-rewards'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrainingRouteImport } from './routes/training'
import { Route as AccountGiftsRouteImport } from './routes/account_.gifts'
import { Route as BibleIndexRouteImport } from './routes/bible.index'
import { Route as BibleChapterRouteImport } from './routes/bible.$chapter'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BookingIndexRouteImport } from './routes/booking.index'
import { Route as CoachingIndexRouteImport } from './routes/coaching.index'
import { Route as CollectionsSlugRouteImport } from './routes/collections.$slug'
import { Route as CommissionsIndexRouteImport } from './routes/commissions.index'
import { Route as CommissionsSlugRouteImport } from './routes/commissions.$slug'
import { Route as CommunityIndexRouteImport } from './routes/community.index'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as FeaturesSlugRouteImport } from './routes/features.$slug'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as HelpIndexRouteImport } from './routes/help.index'
import { Route as JoinIndexRouteImport } from './routes/join.index'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as LibrarySlugRouteImport } from './routes/library.$slug'
import { Route as MatchupsIndexRouteImport } from './routes/matchups.index'
import { Route as MerchIndexRouteImport } from './routes/merch.index'
import { Route as MerchCartRouteImport } from './routes/merch.cart'
import { Route as MerchCheckoutRouteImport } from './routes/merch.checkout'
import { Route as PreviewCustomizationRouteImport } from './routes/preview.customization'
import { Route as PreviewUiRouteImport } from './routes/preview.ui'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopSplatRouteImport } from './routes/shop.$'
import { Route as StreamsIndexRouteImport } from './routes/streams.index'
import { Route as StreamsLiveIdRouteImport } from './routes/streams.$liveId'
import { Route as ToolsPatreonFeeCalculatorRouteImport } from './routes/tools.patreon-fee-calculator'
import { Route as TournamentsIndexRouteImport } from './routes/tournaments.index'
import { Route as TournamentsIdRouteImport } from './routes/tournaments.$id'
import { Route as UseCasesIndexRouteImport } from './routes/use-cases.index'
import { Route as UseCasesSlugRouteImport } from './routes/use-cases.$slug'
import { Route as UseCasesLeagueMatchupBibleRouteImport } from './routes/use-cases.league-matchup-bible'
import { Route as UseCasesLeagueOtpBibleRouteImport } from './routes/use-cases.league-otp-bible'
import { Route as UseCasesMembershipCreatorRouteImport } from './routes/use-cases.membership-creator'
import { Route as CommissionsRequestsRequestIdRouteImport } from './routes/commissions.requests.$requestId'
import { Route as HelpArticlesSlugRouteImport } from './routes/help.articles.$slug'
import { Route as HelpTopicsSlugRouteImport } from './routes/help.topics.$slug'
import { Route as JoinGiftIndexRouteImport } from './routes/join.gift.index'
import { Route as JoinGiftCodeRouteImport } from './routes/join.gift.$code'
import { Route as MatchupsSlugIndexRouteImport } from './routes/matchups.$slug.index'
import { Route as MatchupsSlugSectionRouteImport } from './routes/matchups.$slug.$section'
import { Route as MerchCollectionsSlugRouteImport } from './routes/merch.collections.$slug'
import { Route as MerchOrdersIdRouteImport } from './routes/merch.orders.$id'
import { Route as MerchOrdersDemoRouteImport } from './routes/merch.orders.demo'
import { Route as MerchProductsSlugRouteImport } from './routes/merch.products.$slug'
import { Route as PreviewErrorsStatusRouteImport } from './routes/preview.errors.$status'
import { Route as PreviewPostKindRouteImport } from './routes/preview.post.$kind'
import { Route as UseCasesSlugPreviewIndexRouteImport } from './routes/use-cases.$slug_.preview.index'
import { Route as UseCasesSlugPreviewSplatRouteImport } from './routes/use-cases.$slug_.preview.$'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ForAuthorsRoute = ForAuthorsRouteImport.update({
            id: '/for-authors',path: '/for-authors',getParentRoute: () => rootRouteImport
          })
const ForGymsRoute = ForGymsRouteImport.update({
            id: '/for-gyms',path: '/for-gyms',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LiveRoute = LiveRouteImport.update({
            id: '/live',path: '/live',getParentRoute: () => rootRouteImport
          })
const LolRoute = LolRouteImport.update({
            id: '/lol',path: '/lol',getParentRoute: () => rootRouteImport
          })
const MatchupsRoute = MatchupsRouteImport.update({
            id: '/matchups',path: '/matchups',getParentRoute: () => rootRouteImport
          })
const MembershipAppRoute = MembershipAppRouteImport.update({
            id: '/membership-app',path: '/membership-app',getParentRoute: () => rootRouteImport
          })
const MonthlyRewardsRoute = MonthlyRewardsRouteImport.update({
            id: '/monthly-rewards',path: '/monthly-rewards',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrainingRoute = TrainingRouteImport.update({
            id: '/training',path: '/training',getParentRoute: () => rootRouteImport
          })
const AccountGiftsRoute = AccountGiftsRouteImport.update({
            id: '/account_/gifts',path: '/account/gifts',getParentRoute: () => rootRouteImport
          })
const BibleIndexRoute = BibleIndexRouteImport.update({
            id: '/bible/',path: '/bible/',getParentRoute: () => rootRouteImport
          })
const BibleChapterRoute = BibleChapterRouteImport.update({
            id: '/bible/$chapter',path: '/bible/$chapter',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BookingIndexRoute = BookingIndexRouteImport.update({
            id: '/booking/',path: '/booking/',getParentRoute: () => rootRouteImport
          })
const CoachingIndexRoute = CoachingIndexRouteImport.update({
            id: '/coaching/',path: '/coaching/',getParentRoute: () => rootRouteImport
          })
const CollectionsSlugRoute = CollectionsSlugRouteImport.update({
            id: '/collections/$slug',path: '/collections/$slug',getParentRoute: () => rootRouteImport
          })
const CommissionsIndexRoute = CommissionsIndexRouteImport.update({
            id: '/commissions/',path: '/commissions/',getParentRoute: () => rootRouteImport
          })
const CommissionsSlugRoute = CommissionsSlugRouteImport.update({
            id: '/commissions/$slug',path: '/commissions/$slug',getParentRoute: () => rootRouteImport
          })
const CommunityIndexRoute = CommunityIndexRouteImport.update({
            id: '/community/',path: '/community/',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const FeaturesSlugRoute = FeaturesSlugRouteImport.update({
            id: '/features/$slug',path: '/features/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const HelpIndexRoute = HelpIndexRouteImport.update({
            id: '/help/',path: '/help/',getParentRoute: () => rootRouteImport
          })
const JoinIndexRoute = JoinIndexRouteImport.update({
            id: '/join/',path: '/join/',getParentRoute: () => rootRouteImport
          })
const LibraryIndexRoute = LibraryIndexRouteImport.update({
            id: '/library/',path: '/library/',getParentRoute: () => rootRouteImport
          })
const LibrarySlugRoute = LibrarySlugRouteImport.update({
            id: '/library/$slug',path: '/library/$slug',getParentRoute: () => rootRouteImport
          })
const MatchupsIndexRoute = MatchupsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MatchupsRoute
          })
const MerchIndexRoute = MerchIndexRouteImport.update({
            id: '/merch/',path: '/merch/',getParentRoute: () => rootRouteImport
          })
const MerchCartRoute = MerchCartRouteImport.update({
            id: '/merch/cart',path: '/merch/cart',getParentRoute: () => rootRouteImport
          })
const MerchCheckoutRoute = MerchCheckoutRouteImport.update({
            id: '/merch/checkout',path: '/merch/checkout',getParentRoute: () => rootRouteImport
          })
const PreviewCustomizationRoute = PreviewCustomizationRouteImport.update({
            id: '/preview/customization',path: '/preview/customization',getParentRoute: () => rootRouteImport
          })
const PreviewUiRoute = PreviewUiRouteImport.update({
            id: '/preview/ui',path: '/preview/ui',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => rootRouteImport
          })
const ShopSplatRoute = ShopSplatRouteImport.update({
            id: '/shop/$',path: '/shop/$',getParentRoute: () => rootRouteImport
          })
const StreamsIndexRoute = StreamsIndexRouteImport.update({
            id: '/streams/',path: '/streams/',getParentRoute: () => rootRouteImport
          })
const StreamsLiveIdRoute = StreamsLiveIdRouteImport.update({
            id: '/streams/$liveId',path: '/streams/$liveId',getParentRoute: () => rootRouteImport
          })
const ToolsPatreonFeeCalculatorRoute = ToolsPatreonFeeCalculatorRouteImport.update({
            id: '/tools/patreon-fee-calculator',path: '/tools/patreon-fee-calculator',getParentRoute: () => rootRouteImport
          })
const TournamentsIndexRoute = TournamentsIndexRouteImport.update({
            id: '/tournaments/',path: '/tournaments/',getParentRoute: () => rootRouteImport
          })
const TournamentsIdRoute = TournamentsIdRouteImport.update({
            id: '/tournaments/$id',path: '/tournaments/$id',getParentRoute: () => rootRouteImport
          })
const UseCasesIndexRoute = UseCasesIndexRouteImport.update({
            id: '/use-cases/',path: '/use-cases/',getParentRoute: () => rootRouteImport
          })
const UseCasesSlugRoute = UseCasesSlugRouteImport.update({
            id: '/use-cases/$slug',path: '/use-cases/$slug',getParentRoute: () => rootRouteImport
          })
const UseCasesLeagueMatchupBibleRoute = UseCasesLeagueMatchupBibleRouteImport.update({
            id: '/use-cases/league-matchup-bible',path: '/use-cases/league-matchup-bible',getParentRoute: () => rootRouteImport
          })
const UseCasesLeagueOtpBibleRoute = UseCasesLeagueOtpBibleRouteImport.update({
            id: '/use-cases/league-otp-bible',path: '/use-cases/league-otp-bible',getParentRoute: () => rootRouteImport
          })
const UseCasesMembershipCreatorRoute = UseCasesMembershipCreatorRouteImport.update({
            id: '/use-cases/membership-creator',path: '/use-cases/membership-creator',getParentRoute: () => rootRouteImport
          })
const CommissionsRequestsRequestIdRoute = CommissionsRequestsRequestIdRouteImport.update({
            id: '/commissions/requests/$requestId',path: '/commissions/requests/$requestId',getParentRoute: () => rootRouteImport
          })
const HelpArticlesSlugRoute = HelpArticlesSlugRouteImport.update({
            id: '/help/articles/$slug',path: '/help/articles/$slug',getParentRoute: () => rootRouteImport
          })
const HelpTopicsSlugRoute = HelpTopicsSlugRouteImport.update({
            id: '/help/topics/$slug',path: '/help/topics/$slug',getParentRoute: () => rootRouteImport
          })
const JoinGiftIndexRoute = JoinGiftIndexRouteImport.update({
            id: '/join/gift/',path: '/join/gift/',getParentRoute: () => rootRouteImport
          })
const JoinGiftCodeRoute = JoinGiftCodeRouteImport.update({
            id: '/join/gift/$code',path: '/join/gift/$code',getParentRoute: () => rootRouteImport
          })
const MatchupsSlugIndexRoute = MatchupsSlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => MatchupsRoute
          })
const MatchupsSlugSectionRoute = MatchupsSlugSectionRouteImport.update({
            id: '/$slug/$section',path: '/$slug/$section',getParentRoute: () => MatchupsRoute
          })
const MerchCollectionsSlugRoute = MerchCollectionsSlugRouteImport.update({
            id: '/merch/collections/$slug',path: '/merch/collections/$slug',getParentRoute: () => rootRouteImport
          })
const MerchOrdersIdRoute = MerchOrdersIdRouteImport.update({
            id: '/merch/orders/$id',path: '/merch/orders/$id',getParentRoute: () => rootRouteImport
          })
const MerchOrdersDemoRoute = MerchOrdersDemoRouteImport.update({
            id: '/merch/orders/demo',path: '/merch/orders/demo',getParentRoute: () => rootRouteImport
          })
const MerchProductsSlugRoute = MerchProductsSlugRouteImport.update({
            id: '/merch/products/$slug',path: '/merch/products/$slug',getParentRoute: () => rootRouteImport
          })
const PreviewErrorsStatusRoute = PreviewErrorsStatusRouteImport.update({
            id: '/preview/errors/$status',path: '/preview/errors/$status',getParentRoute: () => rootRouteImport
          })
const PreviewPostKindRoute = PreviewPostKindRouteImport.update({
            id: '/preview/post/$kind',path: '/preview/post/$kind',getParentRoute: () => rootRouteImport
          })
const UseCasesSlugPreviewIndexRoute = UseCasesSlugPreviewIndexRouteImport.update({
            id: '/use-cases/$slug_/preview/',path: '/use-cases/$slug/preview/',getParentRoute: () => rootRouteImport
          })
const UseCasesSlugPreviewSplatRoute = UseCasesSlugPreviewSplatRouteImport.update({
            id: '/use-cases/$slug_/preview/$',path: '/use-cases/$slug/preview/$',getParentRoute: () => rootRouteImport
          })





const MatchupsRouteChildren = {
  MatchupsIndexRoute: MatchupsIndexRoute,MatchupsSlugSectionRoute: MatchupsSlugSectionRoute,MatchupsSlugIndexRoute: MatchupsSlugIndexRoute
}

const MatchupsRouteWithChildren = MatchupsRoute._addFileChildren(MatchupsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,CheckoutRoute: CheckoutRoute,ForAuthorsRoute: ForAuthorsRoute,ForGymsRoute: ForGymsRoute,ForgotPasswordRoute: ForgotPasswordRoute,LiveRoute: LiveRoute,LolRoute: LolRoute,MatchupsRoute: MatchupsRouteWithChildren,MembershipAppRoute: MembershipAppRoute,MonthlyRewardsRoute: MonthlyRewardsRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,TermsRoute: TermsRoute,TrainingRoute: TrainingRoute,AccountGiftsRoute: AccountGiftsRoute,BibleChapterRoute: BibleChapterRoute,BlogSlugRoute: BlogSlugRoute,CollectionsSlugRoute: CollectionsSlugRoute,CommissionsSlugRoute: CommissionsSlugRoute,CompareSlugRoute: CompareSlugRoute,FeaturesSlugRoute: FeaturesSlugRoute,GuidesSlugRoute: GuidesSlugRoute,LibrarySlugRoute: LibrarySlugRoute,MerchCartRoute: MerchCartRoute,MerchCheckoutRoute: MerchCheckoutRoute,PreviewCustomizationRoute: PreviewCustomizationRoute,PreviewUiRoute: PreviewUiRoute,ShopSplatRoute: ShopSplatRoute,StreamsLiveIdRoute: StreamsLiveIdRoute,ToolsPatreonFeeCalculatorRoute: ToolsPatreonFeeCalculatorRoute,TournamentsIdRoute: TournamentsIdRoute,UseCasesSlugRoute: UseCasesSlugRoute,UseCasesLeagueMatchupBibleRoute: UseCasesLeagueMatchupBibleRoute,UseCasesLeagueOtpBibleRoute: UseCasesLeagueOtpBibleRoute,UseCasesMembershipCreatorRoute: UseCasesMembershipCreatorRoute,BibleIndexRoute: BibleIndexRoute,BlogIndexRoute: BlogIndexRoute,BookingIndexRoute: BookingIndexRoute,CoachingIndexRoute: CoachingIndexRoute,CommissionsIndexRoute: CommissionsIndexRoute,CommunityIndexRoute: CommunityIndexRoute,CompareIndexRoute: CompareIndexRoute,GuidesIndexRoute: GuidesIndexRoute,HelpIndexRoute: HelpIndexRoute,JoinIndexRoute: JoinIndexRoute,LibraryIndexRoute: LibraryIndexRoute,MerchIndexRoute: MerchIndexRoute,ShopIndexRoute: ShopIndexRoute,StreamsIndexRoute: StreamsIndexRoute,TournamentsIndexRoute: TournamentsIndexRoute,UseCasesIndexRoute: UseCasesIndexRoute,CommissionsRequestsRequestIdRoute: CommissionsRequestsRequestIdRoute,HelpArticlesSlugRoute: HelpArticlesSlugRoute,HelpTopicsSlugRoute: HelpTopicsSlugRoute,JoinGiftCodeRoute: JoinGiftCodeRoute,MerchCollectionsSlugRoute: MerchCollectionsSlugRoute,MerchOrdersIdRoute: MerchOrdersIdRoute,MerchOrdersDemoRoute: MerchOrdersDemoRoute,MerchProductsSlugRoute: MerchProductsSlugRoute,PreviewErrorsStatusRoute: PreviewErrorsStatusRoute,PreviewPostKindRoute: PreviewPostKindRoute,JoinGiftIndexRoute: JoinGiftIndexRoute,UseCasesSlugPreviewSplatRoute: UseCasesSlugPreviewSplatRoute,UseCasesSlugPreviewIndexRoute: UseCasesSlugPreviewIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)